import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import {
  LocaleContextProvider,
  ErrorBoundary,
} from '@innovatrics/checkin-components'

import App from './App'

ReactDOM.render(
  <ErrorBoundary>
    <LocaleContextProvider>
      <Router>
        <App />
      </Router>
    </LocaleContextProvider>
  </ErrorBoundary>,
  document.getElementById('root')
)
